(function () {
  'use strict';
  // ---------------------------------------------------------------------------
  // Meta in-app browser escape (owner requirement 2026-08-17).
  //
  // Links shared in Instagram/Facebook DMs open inside Meta's in-app WebView,
  // which breaks the shopping/checkout experience. This runs on EVERY theme
  // page (loaded from layout/theme.liquid), so any normal store link the team
  // copies just works — no special wrapper links, and the "keep the full
  // path/query" requirement is free because we are already ON the target page.
  //
  // WHY THE THEME AND NOT A WORKER: erosstore.co's DNS points directly at
  // Shopify (measured 2026-08-17 — nameservers name.com, A 23.227.38.65, no
  // Cloudflare proxy in the owner's account), so no Cloudflare Worker can ever
  // see storefront requests. The theme is the only code that runs on every
  // page of the real domain.
  //
  // Behavior:
  //   • Android + Meta in-app  → immediate Chrome intent:// redirect carrying
  //     the full current URL; if the WebView blocks the auto attempt, a small
  //     bottom banner offers the same jump on tap (user gestures are allowed
  //     where auto-redirects sometimes are not).
  //   • iOS + Meta in-app      → elegant dark Eros overlay instructing the
  //     customer to use ⋯ → "فتح في المتصفح الخارجي" (iOS forbids forcing an
  //     external open). Dismissible — never hard-block browsing.
  //   • Anything else          → completely inert.
  // ---------------------------------------------------------------------------

  var ua = navigator.userAgent || '';
  // Instagram (both platforms), Facebook app (FBAN/FBAV = iOS, FB_IAB/FB4A =
  // Android), Threads ("Barcelona"). Messenger carries FBAN/FBAV too.
  var inMeta = /Instagram|FBAN|FBAV|FB_IAB|FB4A|FBIOS|Barcelona/i.test(ua);
  if (!inMeta) return;

  var isAndroid = /Android/i.test(ua);
  var isIOS = /iPhone|iPad|iPod/i.test(ua);
  if (!isAndroid && !isIOS) return;

  var AUTO_KEY = 'eros_inapp_escape_auto_v1';
  var SEEN_KEY = 'eros_inapp_escape_seen_v1';

  function flag(key) {
    try {
      return window.sessionStorage.getItem(key) === '1';
    } catch (e) {
      return true; // storage blocked — behave as already-shown, never loop
    }
  }
  function setFlag(key) {
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (e) {
      /* best effort */
    }
  }

  function chromeIntentUrl() {
    var l = window.location;
    return (
      'intent://' + l.host + l.pathname + l.search +
      '#Intent;scheme=https;package=com.android.chrome;' +
      'S.browser_fallback_url=' + encodeURIComponent(l.href) + ';end'
    );
  }

  var FONT = "'Vazirmatn', Tahoma, sans-serif";

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // ── Android: jump to Chrome ────────────────────────────────────────────────
  if (isAndroid) {
    if (!flag(AUTO_KEY)) {
      setFlag(AUTO_KEY);
      // Immediate attempt (script is loaded sync in <head>): if the WebView
      // honors intent://, the page unloads into Chrome at this exact URL.
      try {
        window.location.href = chromeIntentUrl();
      } catch (e) {
        /* blocked — the banner below covers it */
      }
    }
    // Banner fallback: some WebView versions block non-gesture navigation to
    // intent:// but allow it from a real tap.
    onReady(function () {
      if (flag(SEEN_KEY)) return;
      var bar = document.createElement('div');
      bar.setAttribute('dir', 'rtl');
      bar.style.cssText =
        'position:fixed;bottom:0;inset-inline:0;z-index:2147483000;' +
        'display:flex;align-items:center;gap:12px;justify-content:space-between;' +
        'background:rgba(24,14,16,.97);color:#F5EFE9;padding:14px 16px calc(14px + env(safe-area-inset-bottom));' +
        'font-family:' + FONT + ';font-size:14px;line-height:1.6;' +
        'box-shadow:0 -6px 24px rgba(0,0,0,.35);';
      var msg = document.createElement('span');
      msg.textContent = 'لتجربة تسوّق وإتمام شراء أفضل، افتحي المتجر في كروم';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'فتح في كروم';
      btn.style.cssText =
        'flex:none;border:0;border-radius:999px;padding:10px 18px;' +
        'background:#F5EFE9;color:#2B181B;font-family:' + FONT + ';' +
        'font-size:14px;font-weight:700;cursor:pointer;';
      btn.addEventListener('click', function () {
        window.location.href = chromeIntentUrl();
      });
      var close = document.createElement('button');
      close.type = 'button';
      close.setAttribute('aria-label', 'إغلاق');
      close.textContent = '×';
      close.style.cssText =
        'flex:none;border:0;background:none;color:#F5EFE9;opacity:.7;' +
        'font-size:20px;line-height:1;cursor:pointer;padding:4px;';
      close.addEventListener('click', function () {
        setFlag(SEEN_KEY);
        bar.remove();
      });
      bar.appendChild(close);
      bar.appendChild(msg);
      bar.appendChild(btn);
      document.body.appendChild(bar);
    });
    return;
  }

  // ── iOS: instruct (forcing an external open is not possible) ──────────────
  onReady(function () {
    if (flag(SEEN_KEY)) return;
    setFlag(SEEN_KEY);

    var overlay = document.createElement('div');
    overlay.setAttribute('dir', 'rtl');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText =
      'position:fixed;inset:0;z-index:2147483000;display:flex;' +
      'align-items:center;justify-content:center;padding:24px;' +
      'background:rgba(18,10,12,.94);backdrop-filter:blur(6px);' +
      '-webkit-backdrop-filter:blur(6px);font-family:' + FONT + ';';

    var card = document.createElement('div');
    card.style.cssText =
      'max-width:420px;width:100%;text-align:center;color:#F5EFE9;';

    var brand = document.createElement('p');
    brand.textContent = 'EROS STORE';
    brand.style.cssText =
      'margin:0 0 6px;font-size:13px;letter-spacing:.35em;opacity:.75;';

    var title = document.createElement('h2');
    title.textContent = 'تجربتج أحلى بالمتصفح الخارجي 🤍';
    title.style.cssText =
      'margin:0 0 14px;font-size:20px;font-weight:800;line-height:1.6;color:#F5EFE9;';

    var steps = document.createElement('p');
    steps.style.cssText =
      'margin:0 0 22px;font-size:15px;line-height:2;color:#E8DCD4;';
    steps.innerHTML =
      'لإتمام الشراء بسهولة وأمان:<br>' +
      '١. اضغطي على النقاط الثلاث <b style="font-size:18px">(⋯)</b> بأعلى الشاشة<br>' +
      '٢. اختاري <b>«فتح في المتصفح الخارجي»</b>';

    var arrow = document.createElement('div');
    arrow.textContent = '↗';
    arrow.style.cssText =
      'position:absolute;top:14px;inset-inline-start:18px;font-size:28px;' +
      'color:#F5EFE9;opacity:.85;';

    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.textContent = 'المتابعة هنا';
    dismiss.style.cssText =
      'border:1px solid rgba(245,239,233,.4);background:none;color:#F5EFE9;' +
      'border-radius:999px;padding:10px 26px;font-family:' + FONT + ';' +
      'font-size:14px;cursor:pointer;opacity:.9;';
    dismiss.addEventListener('click', function () {
      overlay.remove();
      document.documentElement.style.overflow = '';
    });

    card.appendChild(brand);
    card.appendChild(title);
    card.appendChild(steps);
    card.appendChild(dismiss);
    overlay.appendChild(arrow);
    overlay.appendChild(card);
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(overlay);
  });
})();
